import LookupApp from './LookupApp';

function App() {
  return <LookupApp />;
}

export default App;